import { getRequestStatusValue } from "@suse-o11y/request-status";
import React from "react";
import type { RouteComponentProps } from "react-router-dom";

import { selectStackPackStatus } from "../../../app/state/entities/stackPacks/StackPacksSelectors";
import { useNavigateToLink } from "../../../components/react/link";
import { useParametricSelector } from "../../../generic/redux/SelectorUtils";
import { STACKPACKS_INTEGRATION_PATH } from "../../Routes";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

interface RouteParams {
	name: string;
	integration: string;
}

export const StackPacksIntegrationDetailBreadcrumb = ({ match }: RouteComponentProps<RouteParams>) => {
	const status = useParametricSelector(selectStackPackStatus, match.params.name);
	const stackPack = getRequestStatusValue(status);
	const link = useNavigateToLink(STACKPACKS_INTEGRATION_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters", "type"],
		params: {
			name: match.params.name,
			integration: match.params.integration,
		},
	});
	const integration = stackPack?.integrations.find((integration) => integration.name === match.params.integration);

	return integration == null ? null : <BreadcrumbLayout label={integration.displayName} to={link} />;
};

StackPacksIntegrationDetailBreadcrumb.PATH = STACKPACKS_INTEGRATION_PATH;
